
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/author/[author]/[page]",
      function () {
        return require("private-next-pages/articles/author/[author]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/author/[author]/[page]"])
      });
    }
  